var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuApprovalInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.209,
    height: 18,
    viewBox: "0 0 17.209 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_387",
    "data-name": "Union 387",
    d: "M21785,1301.693l-.574-.785a2.241,2.241,0,0,0-2.516-.822l-.93.3a.754.754,0,0,1-.984-.711v-.978a2.242,2.242,0,0,0-1.555-2.14l-.922-.3a.748.748,0,0,1-.375-1.154l.574-.793a2.253,2.253,0,0,0,0-2.641l-.574-.789a.763.763,0,0,1-.107-.674.75.75,0,0,1,.482-.481l.922-.3a2.237,2.237,0,0,0,1.555-2.136v-.978a.759.759,0,0,1,.984-.715l.934.3a2.262,2.262,0,0,0,2.512-.817l.574-.789a.768.768,0,0,1,.605-.292.784.784,0,0,1,.609.292l.57.784a2.253,2.253,0,0,0,2.516.817l.93-.3a.751.751,0,0,1,.984.715v.978a2.247,2.247,0,0,0,1.555,2.136l.922.3a.744.744,0,0,1,.484.481.763.763,0,0,1-.107.674l-.574.789a2.246,2.246,0,0,0,0,2.641l.574.789a.76.76,0,0,1,.107.674.744.744,0,0,1-.484.481l-.922.3a2.257,2.257,0,0,0-1.555,2.144v.978a.751.751,0,0,1-.984.711l-.928-.3a2.243,2.243,0,0,0-2.518.822l-.57.785a.764.764,0,0,1-.609.308A.741.741,0,0,1,21785,1301.693Zm.605-1.717a6.987,6.987,0,0,0,6.645-4.826,6.981,6.981,0,0,0-2.537-7.8,6.995,6.995,0,0,0-8.215,0,6.99,6.99,0,0,0-2.533,7.809,3.745,3.745,0,0,1,2.533,3.491,3.8,3.8,0,0,1,1.113-.168A3.743,3.743,0,0,1,21785.605,1299.976Zm-1.281-4.2-2.25-2.251a.749.749,0,0,1,1.059-1.06l1.723,1.721,3.225-3.225a.75.75,0,0,1,1.059,1.064l-3.754,3.75a.745.745,0,0,1-1.061,0Z",
    transform: "translate(-21777.002 -1284.001)",
    fill: "#a2a3a3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuApprovalInactive);
export default __webpack_public_path__ + "static/media/menu_approval_inactive.f4e709d998a25f4f73b8945c158a02e2.svg";
export { ForwardRef as ReactComponent };